module.exports = __webpack_public_path__ + "img/ic_groups_gray.193cb877.svg";